import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=64d15910&"
import script from "./ReportItem.vue?vue&type=script&lang=ts&"
export * from "./ReportItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports